export default {
  ELECTROLYSIS: 'ELECTROLYSIS',
  STEAM_METHANE_REFORMING: 'STEAM_METHANE_REFORMING',
  STEAM_METHANE_REFORMING_WITH_CO2_CAPTURE:
    'STEAM_METHANE_REFORMING_WITH_CO2_CAPTURE',
  COAL_GASIFICATION: 'COAL_GASIFICATION',
  COAL_GASIFICATION_WITH_CO2_CAPTURE: 'COAL_GASIFICATION_WITH_CO2_CAPTURE',
};
